import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import GridLayout from "../../components/GridLayout"
import PageLayout from "../../components/PageLayout"
import GridTextProjectElement from "../../components/GridTextProjectElement"
import { projectNames } from "../../context/consts"
import Seo from "../../components/Seo"


const YapeDronePage = () => {

    const imageComponents = [
        <StaticImage key={0} src="./../../images/yape/yape-0.jpg" alt="" layout="fullWidth"></StaticImage>,
        <GridTextProjectElement key={1}  projectName={projectNames.YAPE} />,
        <StaticImage key={2} src="./../../images/yape/yape-1.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={3} src="./../../images/yape/yape-2.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={4} src="./../../images/yape/yape-3.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={5} src="./../../images/yape/yape-4.jpg" alt="" layout="fullWidth"></StaticImage>,
    ]

    return (
        <PageLayout firstHead="yape" secondHead="landdrone">
            <GridLayout components={imageComponents}></GridLayout>
            <Seo subTitle="yape landdrone" />
        </PageLayout>
    )

}

export default YapeDronePage